import { createStore } from 'redux';

import type { AppStore } from 'src/models';
import reducer from 'src/reducers';

const getStore = (): AppStore => createStore(reducer);

export default getStore;
